import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BookingsManagerComponent } from './bookings-manager.component';
import { SharedModule } from '../../shared/shared.module';
import { MatCardModule } from '@angular/material/card';
import { AppMaterialModule } from '../../shared/appMaterial/app-material.module';
import { BookingsManagerResolve } from './bookings-manager.resolve';
import { PaginationModule } from '../../shared/pagination/pagination.module';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { ListGridModule } from '../../shared/listGrid/listGrid.module';
import { ManageButtonComponent } from './manage-button/manage-button.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    MatCardModule,
    AppMaterialModule,
    MatSelectModule,
    PaginationModule,
    MatTabsModule,
    ListGridModule,
  ],
  declarations: [BookingsManagerComponent],
  providers: [BookingsManagerResolve, ManageButtonComponent],
})
export class BookingsManagerModule {}
